export function mergeLedgerIntoEnvelope(envelope, ledger) {
  return { ...(envelope || {}), processedSources: Array.isArray(ledger) ? ledger : [] };
}
